import { connect } from 'react-redux';
import { updateInstitutionInformation } from '../actions';
import InstitutionInformationForm from './InstitutionInformationForm';
var mapStateToProps = function mapStateToProps(_ref, _ref2) {
  var account = _ref.account;
  var userIdentity = _ref2.userIdentity,
    apiRoot = _ref2.apiRoot,
    formData = _ref2.formData;
  return {
    apiRoot: apiRoot,
    formData: formData,
    status: account.status,
    userIdentity: userIdentity
  };
};
var mapDispatchToProps = {
  updateInstitutionInformation: updateInstitutionInformation
};
export default connect(mapStateToProps, mapDispatchToProps)(InstitutionInformationForm);